import { IDENTITY_PROVIDERS } from 'common/constants/constants';
import GithubOrgsSelector from './form-components/GithubOrgsSelector/GithubOrgsSelector';
import {
  StyledOrgDetectionStrategy,
  StyledRadioLabel
} from './MonitoringRulesForm.style';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { ORG_DETECTION_STRATEGY } from './useFormState/formState.types';
import useGithubOrgsOptions from './form-components/GithubOrgsSelector/useGithubOrgsOptions';
import OrgDetectionRegex from './form-components/OrgDetectionRegex/OrgDetectionRegex';

const OrgDetectionStrategy = ({ integration, formState }) => {
  const sensorName = integration?.sensor_name;
  const githubOrgs = useGithubOrgsOptions(
    integration,
    formState.selectedGithubOrgs
  );

  return (
    <StyledOrgDetectionStrategy>
      <header>
        Select organizations to automatically add repos based on the rules
        above:
      </header>
      <RadioGroup
        name='limit-toggler-group'
        value={formState.orgDetectionStrategy}
        onChange={(e, strategy) =>
          formState.switchOrgDetectionStrategy(strategy)
        }
      >
        <div className='flex flex-row items-center'>
          <FormControlLabel
            data-cy={'select-org-regex'}
            value={ORG_DETECTION_STRATEGY.REGEX}
            control={<Radio color='primary' data-cy='select-org-by-regex' />}
          />
          <StyledRadioLabel>Select organizations by regex</StyledRadioLabel>
          <OrgDetectionRegex
            value={formState.orgDetectionStrategyRegex}
            onChange={formState.setOrgDetectionStrategyRegex}
            disabled={
              formState?.orgDetectionStrategy !== ORG_DETECTION_STRATEGY.REGEX
            }
            githubOrgs={githubOrgs}
          />
        </div>
        <div className='flex flex-row items-start'>
          <FormControlLabel
            value={ORG_DETECTION_STRATEGY.ORG_SELECTION}
            control={<Radio color='primary' data-cy='select-org-manually' />}
          />
          <div className='flex flex-row items-start'>
            <StyledRadioLabel>Select organizations manually</StyledRadioLabel>
            {sensorName === IDENTITY_PROVIDERS.GITHUB && (
              <GithubOrgsSelector
                githubOrgs={githubOrgs}
                integration={integration}
                onChange={formState.onChangeGithubOrg}
                filterUnExistedOrgs={formState.filterUnExistedOrgs}
                selectedValues={formState.selectedGithubOrgs}
                disabled={
                  formState?.orgDetectionStrategy !==
                  ORG_DETECTION_STRATEGY.ORG_SELECTION
                }
              />
            )}
          </div>
        </div>
      </RadioGroup>
    </StyledOrgDetectionStrategy>
  );
};

export default OrgDetectionStrategy;
